jQuery(document).ready(function () {
    if(jQuery('.hero-block-prestige-hp-wrapper').length > 0)
    {
        jQuery('.hero-block-prestige-hp-wrapper .overlay-wrapper-prestige .heading').addClass('active');
        jQuery('.hero-block-prestige-hp-wrapper .overlay-wrapper-prestige .header-logo').addClass('hidden');
    }

    jQuery('.menu-item > a').click(function(){
        var _href = jQuery(this).attr('href');
        if(_href != '')
            location.href = _href;
    });
});

if(detectMob())
{
    // if(jQuery('.hero-hp-slider-wrapper').length > 0)
    // {
    //     jQuery('.hero-hp-slider-wrapper').removeClass("hide");
    //     jQuery('.hero-hp-slider-wrapper').addClass("mobile_image_background");

    //     jQuery('.hero-hp-video-wrapper').addClass("hide");
    //     jQuery('.hero-hp-youtube-wrapper').addClass("hide");
    // }
}
else 
{
    if(jQuery('.hero-hp-youtube-wrapper').length > 0 && jQuery('.hero-hp-youtube-wrapper').hasClass('active_media_type'))
    {
        jQuery('.hero-hp-youtube-wrapper').removeClass("hide");
        jQuery('.hero-hp-slider-wrapper').addClass("hide");
    }

    if(jQuery('.hero-hp-video-wrapper').length > 0 && jQuery('.hero-hp-video-wrapper').hasClass('active_media_type'))
    {
        jQuery('.hero-hp-video-wrapper').removeClass("hide");
        jQuery('.hero-hp-slider-wrapper').addClass("hide");
    }

    // if(jQuery('.hero-hp-slider-wrapper').length > 0 && jQuery('.hero-hp-slider-wrapper').hasClass('active_media_type'))
    // {
    //     jQuery('.hero-hp-slider-wrapper').removeClass("hide");
    // }

    if(jQuery('.hero-block-prestige-wrapper').length > 0)
    {
        jQuery('.hero-block-prestige-wrapper').addClass("mobile_image_background");
    }

    if(jQuery('.hero-block-parallax-prestige-wrapper').length > 0)
    {
        jQuery('.hero-block-parallax-prestige-wrapper').addClass("mobile_image_background");
    }
}

function detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}